import React from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import theme from '../theme';

export default function Avatar({ name, size = 40 }: any){
  const initials = (name || 'U').split(' ').map((s:string)=>s[0]).slice(0,2).join('').toUpperCase();
  return (
    <View style={[styles.container, {width:size, height:size, borderRadius: size/2}]}>
      <Text style={[styles.txt, {fontSize: Math.max(12, size/3)}]}>{initials}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { backgroundColor: '#15202B', alignItems:'center', justifyContent:'center', overflow:'hidden' },
  txt: { color: theme.colors.textPrimary, fontWeight: '700' }
});